import {
  EMAIL_LENGTH_VALIDATION,
  EMAIL_TYPE_VALIDATION,
  EMPTY_INPUT_VALUE_VALIDATOR,
  ERROR_REQUIRED_FIELD,
} from '@app/constants';

export const fields = [
  {
    label: 'Фамилия',
    name: 'NameLast',
    required: false,
    rules: [],
    labelTestId: 'surname',
    inputTestId: 'surname-input',
    maxLength: 60,
  },
  {
    label: 'Имя',
    name: 'NameFirst',
    required: true,
    rules: [
      { required: true, message: ERROR_REQUIRED_FIELD },
      EMPTY_INPUT_VALUE_VALIDATOR,
    ],
    labelTestId: 'name',
    inputTestId: 'name-input',
    maxLength: 60,
  },
  {
    label: 'Отчество',
    name: 'NameMiddle',
    required: false,
    rules: [],
    labelTestId: 'patronymic',
    inputTestId: 'patronymic-input',
    maxLength: 80,
  },
  {
    label: 'Email',
    name: 'Email',
    rules: [EMAIL_TYPE_VALIDATION, EMAIL_LENGTH_VALIDATION],
    required: false,
    labelTestId: 'email',
    inputTestId: 'email-input',
    maxLength: 100,
  },
];
